module.exports = __webpack_public_path__ + "static/DHCM1-41cc0ee8a507280dff369bbba8083d29.jpg";